module.exports = __webpack_public_path__ + "static/media/add-outline.5123d099.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/add-outline.svg
// module id = 842
// module chunks = 0